export default "__VITE_ASSET__Dt7hA386__"